import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router";
import { api } from "../../lib/api";
import { persistRoundSelection } from "../../lib/roundSelection";
import { ManualRoundBuilderPage } from "./ManualRoundBuilderPage";
import "./manual-round-builder-route.css";

function seasonFrom(value: string | null) {
  const season = Number(value || new Date().getFullYear());
  return Number.isFinite(season) && season >= 2020 && season <= 2100 ? season : new Date().getFullYear();
}

function todayIso() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
}

export function ManualRoundBuilderRoute() {
  const [params, setParams] = useSearchParams();
  const season = seasonFrom(params.get("season"));
  const tournamentId = params.get("tournament") || "";
  const tournaments = useQuery({ queryKey: ["tournaments", season], queryFn: () => api.tournaments(season), staleTime: 30_000 });
  const selected = (tournaments.data?.tournaments || []).find((item) => item.id === tournamentId);

  function openTournament(id: string, itemSeason: number) {
    const next = new URLSearchParams();
    next.set("tournament", id);
    next.set("season", String(itemSeason));
    next.set("round", "R1");
    setParams(next);
    persistRoundSelection(id, "R1", itemSeason);
  }

  function leaveTournament() {
    setParams({ season: String(season) });
  }

  if (!tournamentId || (!tournaments.isPending && !selected)) {
    const today = todayIso();
    const rows = [...(tournaments.data?.tournaments || [])]
      .filter((item) => !item.endDate || item.endDate >= today)
      .sort((left, right) => (left.startDate || "9999").localeCompare(right.startDate || "9999"));
    return <section className="generator-tournament-picker manual-tournament-picker">
      <article className="generator-picker-hero panel"><div><span className="eyebrow">MANUALNY KREATOR</span><h2>Wybierz turniej</h2><p>Manualny kreator pokazuje bieżący i przyszłe turnieje. Zakończone wydarzenia pozostają w archiwum ogólnym i nie zaśmiecają listy roboczej.</p></div><label><span>Sezon</span><select value={season} onChange={(event) => setParams({ season: event.target.value })}>{[2026, 2025, 2024].map((value) => <option key={value} value={value}>{value}</option>)}</select></label></article>
      {tournaments.isPending ? <article className="panel generator-picker-loading">Wczytuję turnieje…</article> : rows.length ? <div className="generator-picker-grid">{rows.map((item) => <button type="button" className="generator-picker-card" key={item.id} onClick={() => openTournament(item.id, item.season)}><span>{item.startDate || "Brak daty"}{item.endDate ? ` → ${item.endDate}` : ""}</span><strong>{item.name}</strong><small>Otwórz kreator →</small></button>)}</div> : <article className="panel generator-picker-loading">Brak bieżących lub przyszłych turniejów w sezonie {season}.</article>}
    </section>;
  }

  return <div className="manual-builder-route"><div className="manual-context-bar"><div><small>AKTYWNY TURNIEJ</small><strong>{selected?.name}</strong></div><button type="button" className="secondary-button" onClick={leaveTournament}>← Wybierz inny turniej</button></div><ManualRoundBuilderPage /></div>;
}
